import api from './api';

const ENDPOINT = 'informatives';

const InformativeService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
};

export default InformativeService;
